import "@/lib/theme";  // first: applies the saved look (Classic / Catalogue) before the first paint
import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/styles/theme-catalogue.css";  // scoped to <html data-ui-theme="catalogue">; Classic is unaffected
import "@/styles/theme-glass.css";      // opt-in staff theme; Classic and Catalogue stay unchanged
import "@/styles/theme-glass-finish.css"; // final approved preview finish, scoped to Glass

// The customer catalogue (galeri.artevastories.com, or /katalog while staged inside ops) is its own lazily
// loaded bundle: customers never download the internal ARTEVA CORE application code, and vice versa.
const isCatalogue = window.location.hostname.startsWith("galeri.") || /^\/katalog(\/|$)/.test(window.location.pathname);
const App = lazy(() => import("@/App"));
const CatalogueApp = lazy(() => import("@/components/catalogue/CatalogueApp"));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Staff app language (EN/ID): the translator swaps rendered texts; the printer's download page (/p/) stays Indonesian.
if (!isCatalogue && !/^\/p\//.test(window.location.pathname)) {
  import("@/lib/i18n").then(({ startTranslator }) => startTranslator());
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      {isCatalogue ? <CatalogueApp /> : (
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      )}
    </Suspense>
  </React.StrictMode>,
);
